import { Box, Button } from "@mui/material";
import { makeStyles } from "@mui/styles";
import React from "react";

const BottomButton = (props) => {
  const {
    title = "", onClick, onBack,
    disabled = false,
    fessTotal
  } = props;
  const classes = styles();

  return (
    <Box className={classes.container}>
      <div className={`${!onBack ? "center" : "between"}`}
        style={{ display: "flex", flexDirection: "column", gap: 16 }}
      >
        {!!fessTotal && (
          <div style={{ display: "flex", justifyContent: "space-between", fontSize: 16 }}>
            <div>Tổng tiền thanh toán:</div>
            <div style={{ color: "#009B4B", fontWeight: 600 }}>{`${(fessTotal || 0)
              }`.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}{" "}VNĐ</div>
          </div>
        )}
        <div style={{justifyContent: "space-between", display: "flex"}}>
          {!!onBack && (
            <Button className="btn back" onClick={onBack}>
              Quay lại
            </Button>
          )}
          <Button
            disabled={!!disabled}
            className={`btn next ${!onBack ? "w-90" : ""}`}
            onClick={onClick}
          >
            {title}
          </Button>
        </div>
      </div>
    </Box>
  );
};

export default BottomButton;

const styles = makeStyles(() => ({
  container: {
    position: "sticky",
    zIndex: 12,
    width: "calc(100% - 32px)",
    bottom: 0,
    left: 0,
    boxShadow: "0px -4px 8px rgba(63, 81, 181, 0.1)",
    alignItems: "center",
    background: "#fff",
    padding: "16px",
    paddingBottom: "42px",
    borderRadius: "16px 16px 0px 0px",

    "& .between": {
      display: "flex",
      justifyContent: "space-between",
    },
    "& .center": {
      display: "flex",
      justifyContent: "center",
    },
    "& .Mui-disabled": {
      background: "#F0F8FF !important",
    },

    "& .btn": {
      width: "48%",
      borderRadius: "8px",
      fontSize: 15,
      fontWeight: 600,
      alignItems: "center",
      textAlign: "center",
      textTransform: "none",
    },

    "& .w-90": {
      width: "100%",
    },

    "& .back": {
      border: "1px solid #009B4B",
      color: "#009B4B",
    },

    "& .next": {
      backgroundColor: "#009B4B",
      color: "white",
      "&:hover": {
        backgroundColor: "#009B4B",
      },
    },
  },
}));
